export default class Browser {

  // Recupera parametros de filtro da URL e atribui ao state de filtros
  static recoverFilterFromURL (route, filters = {}, pagination = {}) {
    let key = null
    for (let index in route.query) {
      key = index
      if (key === 'current_page' || key === 'per_page') {
        pagination[key] = route.query[index]
      } else {
        filters[key] = route.query[index]
      }
    }
  }

  // Atribui parametros de filtro do state na URL
  static filtersToURL (router, filters = {}, path = '') {
    let query = {}
    for (let index in filters) {
      if (filters[index] !== 'NaN' && filters[index] !== '' && filters[index] !== 0) {
        query[index] = filters[index]
      }
    }
    router.replace({path: path, query: query})
  }
}



// WEBPACK FOOTER //
// ./src/utils/browser.js